const url = process.env.REACT_APP_API_URL + "/api";
export default {
  get: (id) => `${url}/building_area_usage/${id}/`,
  list: (projectId) => `${url}/building_area_usage/?project_id=${projectId}`,
};
